var map = {
	"./gallery - story - heart (1)_00.jpg": 2509,
	"./gallery - story - heart (1)_01.jpg": 2510,
	"./gallery - story - heart (1)_02.jpg": 2511,
	"./gallery_00.jpg": 2512,
	"./gallery_01.jpg": 2513,
	"./gallery_02.jpg": 2514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2508;